import { css } from "@emotion/css";

export const lensNameWidth = css`
    flex-grow: 1;
    min-width: 100px;
`;

export const iconWidth = css`
    width: 72px;
`;

export const statusWidth = css`
    flex-shrink: 0;
    width: 126px;
`;
